import React from 'react'
import { Redirect } from 'react-router-dom'
import LinearProgress from '@material-ui/core/LinearProgress'
import useAchievementsAuth from './useAchievementsAuth'

function withAchievementsProtectedRoute(Page) {
  function WithAchievementsProtectedRoute(props) {
    const { isAuthenticated, isLoading, verifySession } = useAchievementsAuth()

    React.useEffect(() => {
      verifySession()
    }, [verifySession])

    if (isLoading) {
      return <LinearProgress color="secondary" />
    }

    if (!isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: '/achievements/login',
            state: { from: props.location },
          }}
        />
      )
    }

    return <Page {...props} />
  }

  WithAchievementsProtectedRoute.displayName = `withAchievementsProtectedRoute(${Page.displayName ||
    Page.name ||
    'Component'})`

  return WithAchievementsProtectedRoute
}

export default withAchievementsProtectedRoute
